
import { initializeBindings } from "https://static.cloud.coveo.com/atomic/v3/index.esm.js";
import { resultContext } from "https://static.cloud.coveo.com/atomic/v3/index.esm.js";
import { loadGenericAnalyticsActions } from 'https://static.cloud.coveo.com/headless/v3/headless.esm.js';


class CTACustomLink extends HTMLElement {
    result;
    initialized = false;

    async connectedCallback() {
        if (this.initialized) {
            return;
        }
        this.bindings = await initializeBindings(this);
        this.initialized = true;
        this.result = await resultContext(this);
        this.render();
    }

    render() {
        const uri = this.result.clickUri;
        const template = this.querySelector(`:scope > template[data-role="cta-custom-link"]`);

        if (!(template instanceof HTMLTemplateElement)) {
            return;
        }

        const fragment = template.content.cloneNode(true);
        fragment.querySelector(`.result-cta-link`).setAttribute('href', uri);
        fragment.querySelector(`.result-cta-link`).innerHTML = this.result.raw.ctalabel;

        this.prepend(fragment);

        const button = this.querySelector(".result-cta-link");
        button?.setAttribute("aria-labelledby", this.result.raw.ctalabel);
        button?.addEventListener("click", this.customEvent.bind(this));
    }

    customEvent() {
        const {logCustomEvent} = loadGenericAnalyticsActions(this.bindings.engine);
        const pagecontenttype = Array.isArray(this.result?.raw?.pagecontenttype)
            ? this.result.raw.pagecontenttype[0]
            : this.result?.raw?.pagecontenttype;
        const payload = {
            evt: pagecontenttype,
            type: "ctalinkClick",
        }
        this.bindings.engine.dispatch(logCustomEvent(payload));
    }
}

if (!window.customElements.get("cta-custom-link")) {
    window.customElements.define("cta-custom-link", CTACustomLink);
}